/*****************setting*****************/
export const TOGGLE_SIDEBAR = "toggleSidebar";
export const OPEN_MENU_KEY_EQUAL_ROUTE = "openMenuKeyEqualRout";
export const SET_MENU_ITEM = "setMenuItem";
export const UPDATE_WINDOW_WIDTH = "updateWindowWidth";
export const TAB_SIZE = 991;

/****************Authenticate***************/
export const GET_AUTH_DATA = "getAuthData";
export const IS_TOKEN_ALIVE = "isTokenAlive";

export const SIGNUP_USER_SUCCESS = "userSignUpSuccess";
export const SIGNIN_USER_SUCCESS = "userSignInSuccess";
export const SIGNOUT_USER_SUCCESS = "userSignOutSuccess";
export const GET_USER_DATA = "getUserData";
export const SHOW_MESSAGE = "showAuthMessage";
export const HIDE_MESSAGE = "hideMessage";
export const ON_SHOW_LOADER = "showAuthLoader";
export const ON_HIDE_LOADER = "hideAuthLoader";
export const INIT_URL = "initUrl";

/********************plan*******************/
export const TOTAL_PRICE = "totalPrice";
export const TOTAL_PRICE_NUM = "totalPriceNum";
export const SET_RAM = "setRam";
export const SET_CPU = "setCpu";
export const SET_STORAGE = "setStorage";
export const SET_RESOURCE = "setResource";
export const SET_DEFAULT_RESOURCE = "setDefaultResource";
export const SET_RESOURCE_SERVICE = "setResourceService";
export const HIDE_ERRORMESSAGE = "hideErrorMessages";

/********************service*******************/
export const SET_DEFAULT_STATE_SERVICE = "setDefaultStateService";

export const SET_DATABASE_LIST = "setDatebaseList";
export const SET_READY_APPS_LIST = "setReadyAppsList";
export const SET_CUSTOM_APPS_LIST = "setCustomAppsList";

export const SELECT_DATABASE = "selectDatabase";
export const SELECT_READY_APPS = "selectReadyApps";
export const SELECT_CUSTOM_APPS = "selectCustomApps";

export const SET_USER_DB_LIST = "setUserDbList";
export const SET_USER_DB_SELECTED = "setUserDbSelected";

export const SET_READY_APP_SELECTED_VERSION = "setReadyAppSelectedVersion";
export const SET_CUSTOM_APP_SELECTED_VERSION = "setReadyAppSelectedVersion";
export const SET_DATABASE_SELECTED_VERSION = "setReadyAppSelectedVersion";

export const SET_TYPE_SERVICE = "setTypeService";
export const UPDATE_SERVICE_NAME = "updateServiceName";
export const BLUR_INPUT_SERVICE_NAME = "blurInputServiceName";

/*************************StatsMonitoringApp***************************/

export const SET_STATS = "setStats";

/*******************************Header********************************/

export const SET_HEADER_INFO = "setHeaderInfo";
export const GET_BALANCE_UNREAD_MESSAGE = "getBalanceUnReadMessage";
export const GET_USERNAME = "getUsername";
